module.exports = __webpack_public_path__ + "assets/images/TTD10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/TTD10.png
// module id = 1433
// module chunks = 1